<template>
	<div
		ref="modal"
		@click.prevent.stop="close"
		tabindex="-1"
		class="fixed w-full h-screen bg-gray-800/50 backdrop-blur-sm md:backdrop-blur-md opacity-0 transition-all duration-500 flex items-start sm:items-center justify-center z-[100] inset-0 !m-0 overscroll-none cursor-default"
		:class="[{ '!opacity-100': fadeIn }, fullScreenMobile ? '!bg-white sm:!bg-gray-800/50 !backdrop-blur-none sm:!backdrop-blur-sm md:!backdrop-blur-md' : '']"
		aria-modal="true"
		v-show="active"
		role="dialog"
	>
		<!-- fixed w-full h-screen backdrop-blur-2xl md:backdrop-blur-md opacity-0 transition-all duration-500 -->

		<div class="relative w-full" :class="[maxWidth, fullScreenMobile ? 'm-0 h-full sm:m-2 sm:h-auto' : 'm-2']">
			<button
				@click.prevent.stop="close"
				class="absolute -top-3 -right-3 z-10 rounded-full h-10 w-10 border-2 bg-white"
				v-if="!hideX"
				:class="{ 'hidden sm:block': fullScreenMobile }"
			>
				<div class="m-auto items-center flex w-full justify-center">
					<div class="rotate-45 absolute rounded bg-ihh-slate-gray group-hover:bg-ihh-white py-0.5 px-3"></div>
					<div class="-rotate-45 rounded bg-ihh-slate-gray group-hover:bg-ihh-white py-0.5 px-3"></div>
				</div>
			</button>
			<div
				ref="modalContent"
				@click.stop
				class="shadow-card w-full p-4 md:p-8 relative space-y-4 md:space-y-8"
				:class="[
					dialogClasses,
					maxWidth,
					allowOverflow ? 'overflow-visible' : 'overflow-y-scroll',
					warning ? 'bg-ihh-warning border-ihh-warning' : 'bg-white',
					fullScreenMobile ? 'rounded-none border-0 max-h-screen h-full sm:rounded sm:border sm:max-h-[75vh] sm:h-auto' : 'rounded border max-h-[75vh]',
				]"
			>
				<slot :close="close" />
			</div>
		</div>
	</div>
	<!-- max-w-md max-w-lg max-w-xl max-w-sm -->
</template>

<script>
export default {
	props: {
		dialogClasses: { type: String, default: '' },
		maxWidth: { default: 'max-w-md' },
		active: { default: true },
		allowOverflow: { type: Boolean, default: false },
		warning: { type: Boolean, default: false },
		hideX: { type: Boolean, default: false },
		fullScreenMobile: { type: Boolean, default: false },
	},
	data() {
		return {
			fadeIn: false,
		}
	},
	watch: {
		active: {
			handler() {
				if (this.active) this.freeze()
				else this.thaw()
			},
			immediate: true,
		},
	},
	beforeDestroy() {
		this.thaw()
	},
	unmounted() {
		this.thaw()
	},
	methods: {
		freeze() {
			this.$nextTick(() => {
				this.$refs.modalContent?.focus()
				this.fadeIn = true
				document.body.style.overflow = 'hidden'
				document.getElementById('app').setAttribute('aria-hidden', 'true')
				this.$refs?.modal?.setAttribute('aria-modal', 'true')
				this.attachListeners()
			})
		},
		thaw() {
			document.body.style.overflow = ''
			document.getElementById('app').setAttribute('aria-hidden', 'false')
			this.$refs?.modal?.removeAttribute('aria-modal')
			this.removeListeners()
		},
		close() {
			this.fadeIn = false
			this.thaw()
			setTimeout(() => {
				this.$emit('hide')
			}, 500)
		},
		attachListeners() {
			window.addEventListener('keydown', this.handleKeydown)
		},
		removeListeners() {
			window.removeEventListener('keydown', this.handleKeydown)
		},
		handleKeydown(e) {
			if (e.key === 'Tab') {
				this.manageFocus(e)
			} else if (e.key === 'Escape') {
				this.close()
			}
		},
		manageFocus(e) {
			let focusable = Array.from(this.$refs.modal.querySelectorAll('button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'))
			focusable = focusable.filter((el) => window.getComputedStyle(el).display !== 'none')
			console.log('focusable', focusable)

			if (!focusable.includes(document.activeElement)) {
				e.preventDefault()
				focusable[0].focus()
			} else if (e.shiftKey && document.activeElement === focusable[0]) {
				e.preventDefault()
				focusable[focusable.length - 1].focus()
			} else if (document.activeElement === focusable[focusable.length - 1]) {
				e.preventDefault()
				focusable[0].focus()
			}
		},
	},
}
</script>
